var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gs-button',{staticClass:"gs-copy-button",attrs:{"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled || !_vm.hasSomethingToCopy,"title":_vm.title || _vm.label},on:{"click":function($event){return _vm.copy()}}},[_c('gs-icon',{attrs:{"name":_vm.icon,"size":"15"}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }